<!-- header -->
<app-header></app-header>

<!-- shell -->
<router-outlet></router-outlet>

<!-- footer -->
<app-footer></app-footer>

<!-- toast -->
<app-toasts aria-live="polite" aria-atomic="true"></app-toasts>